import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Product } from '@utils/product';
import { TitleAndSubtitle, ProductImage } from 'audamatic-ui';
import Link from '../../base_link/component';

import './styles/styles.scss';

class BannerCollection extends Component {
  get booklist() {
    const { products = [] } = this.props;
    return products.slice(0, 3).map((_product, index) => {
      const product = new Product(_product);
      return (
        <div className="product-image-wrapper">
          <ProductImage key={index} product={product} />
        </div>
      );
    });
  }

  render() {
    const { title, subtitle, url = '#' } = this.props;

    return (
      <Link href={url} className="collection-banner banner">
        <div className="booklist-images">
          <div className="centered-images">{this.booklist}</div>
        </div>
        <div className="align-to-bottom-container">
          <div className="collection-headings">
            <TitleAndSubtitle
              title={title}
              subtitle={subtitle}
            />
          </div>
        </div>
      </Link>
    );
  }
}

BannerCollection.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  url: PropTypes.string,
  products: PropTypes.array,
  collectionLink: PropTypes.bool,
  collectionUrl: PropTypes.string,
  collectionTitle: PropTypes.string,
  buttonText: PropTypes.string,
};


export default BannerCollection;
